// extracted by mini-css-extract-plugin
export var accordion = "_dx-0";
export var chevron = "_dx-3";
export var closed = "_dx-2";
export var content = "_dx-4";
export var open = "_dx-1";
export var rotate = "_dx-5";